import React from 'react';
import { useDiwaliOffer } from '../hooks/useDiwaliOffer';

const Flame = ({ accent }) => (
  <span className="relative inline-flex w-3.5 h-3.5 items-center justify-center shrink-0" aria-hidden="true">
    <span className="absolute inset-0 rounded-full blur-[6px] opacity-80 animate-[diya-glow_1.8s_ease-in-out_infinite]" style={{ background: '#FFB547' }} />
    <svg viewBox="0 0 16 16" className="relative w-3.5 h-3.5">
      <path d="M8 1.2c1.9 2.5 2.9 4.3 2.9 5.7a2.9 2.9 0 0 1-5.8 0c0-1.4 1-3.2 2.9-5.7z" fill="#FFB547" className="origin-bottom animate-[diya-flicker_1.6s_ease-in-out_infinite]" />
      <path d="M8 4.6c.7 1 1 1.7 1 2.3a1 1 0 0 1-2 0c0-.6.3-1.3 1-2.3z" fill="#FFF3D6" />
      <path d="M1.5 10.2h13c-.5 2.6-3.2 4.6-6.5 4.6s-6-2-6.5-4.6z" fill={accent} />
    </svg>
  </span>
);

export const DiwaliBadge = ({ accent = '#E02128', testId = 'diwali-offer-badge', className = '' }) => {
  const cfg = useDiwaliOffer();
  if (!cfg?.badges) return null;
  return (
  <span
    className={`relative inline-flex p-px rounded-full overflow-hidden bg-[length:200%_100%] animate-[gradient-x_3s_linear_infinite] ${className}`}
    style={{ backgroundImage: `linear-gradient(90deg, ${accent}, #FFB547, ${accent})`, boxShadow: `0 6px 22px ${accent}40` }}
    data-testid={testId}
  >
    <span className="relative inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] pl-2.5 pr-3.5 py-1.5 overflow-hidden">
      <Flame accent={accent} />
      <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-white whitespace-nowrap">
        Diwali Offer <span className="text-white/30 mx-0.5">/</span> <span style={{ color: '#FFB547' }}>New Prices</span>
      </span>
      <span className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-white/25 to-transparent skew-x-[-20deg] animate-[chrome-shine_3.2s_ease-in-out_infinite]" />
    </span>
  </span>
);
};
